import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthFormComponent, AuthMode } from '../../shared/auth-form.component';
import { User } from '../../shared/UserInterface';
import { isSafeReturnUrl } from '../../../shared/utils/return-url.util';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [AuthFormComponent],
  template: `
    <div class="auth-page-container">
      <!-- <div class="auth-page-header">
        <h1 class="auth-page-title">
          {{ initialMode === AuthMode.LOGIN ? 'Sign in to your account' : 'Create your account' }}
        </h1>
        <p class="auth-page-subtitle">
          {{ initialMode === AuthMode.LOGIN ? 'Don\'t have an account?' : 'Already have an account?' }}
          <a [routerLink]="['/login']" [queryParams]="initialMode === AuthMode.LOGIN ? {mode: 'signup'} : {}" class="auth-page-link">
            {{ initialMode === AuthMode.LOGIN ? 'Create one now' : 'Sign in instead' }}
          </a>
        </p>
      </div> -->
      
      <app-auth-form
        [isModal]="false"
        [showHeader]="false"
        [initialMode]="initialMode"
        (authSuccess)="onAuthSuccess($event)">
      </app-auth-form>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  AuthMode = AuthMode;
  initialMode = AuthMode.LOGIN;
  
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}
  
  ngOnInit() {
    // Check URL parameters to determine which mode to display
    this.route.queryParams.subscribe(params => {
      if (params && params['mode'] === 'signup') {
        this.initialMode = AuthMode.SIGNUP;
      } else {
        this.initialMode = AuthMode.LOGIN;
      }
    });
  }
  
  onAuthSuccess(user: User): void {
    // Handle navigation after successful login/signup. Only follow returnUrl
    // if it's a relative in-app path (avoid open redirect).
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];

    if (isSafeReturnUrl(returnUrl)) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigate(['/profile']);
    }
  }
}